var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAu2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 92,
    height: 69,
    viewBox: "0 0 92 69",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.8712 40.9971C42.7528 36.7623 39.2864 33.3937 34.9533 31.4688C31.6794 33.6824 27.7315 35.0299 23.3985 35.0299C19.1617 35.0299 15.2138 33.6824 11.8437 31.4688C4.91079 34.5486 0 41.4784 0 49.563V57.8402C0 59.4764 1.25177 60.7276 2.8887 60.7276H38.6123V57.8402C38.6123 51.3917 40.9233 45.617 44.8712 40.9971Z",
    fill: "#2C3C58"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3992 29.0664C31.3913 29.0664 37.939 22.5216 37.939 14.5332C37.939 6.54475 31.3913 0 23.3992 0C15.4071 0 8.85938 6.54475 8.85938 14.5332C8.85938 22.5216 15.4071 29.0664 23.3992 29.0664Z",
    fill: "#2C3C58"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M79.633 39.7422C76.3591 42.0521 72.3149 43.3033 68.0782 43.3033C63.8414 43.3033 59.7972 41.9559 56.5234 39.7422C49.4942 42.8221 44.6797 49.7518 44.6797 57.8365V66.1137C44.6797 67.7499 46.0277 69.0011 47.5684 69.0011H88.6842C90.3212 69.0011 91.573 67.7499 91.573 66.1137V57.8365C91.4767 49.7518 86.5659 42.7258 79.633 39.7422Z",
    fill: "#2C3C58"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M68.0867 37.2383C76.0788 37.2383 82.6265 30.6935 82.6265 22.7051C82.6265 14.7166 76.0788 8.17188 68.0867 8.17188C60.0946 8.17188 53.5469 14.7166 53.5469 22.7051C53.5469 30.6935 59.9983 37.2383 68.0867 37.2383Z",
    fill: "#2C3C58"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAu2);
export default __webpack_public_path__ + "static/media/au2.11c25f60cfd5d69d30d0eee08af5274b.svg";
export { ForwardRef as ReactComponent };